module.exports = __webpack_public_path__ + "img/default-avatar.7d9068a9.png";